import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import POSDevices from "./pages/POSDevices";
import Wallet from "./pages/Wallet";
import About from "./pages/About";
import Contact from "./pages/Contact";
import WhoIsRoyaFor from "./pages/WhoIsRoyaFor";
import { Toaster } from "./components/ui/sonner";
import SplashScreen from "./components/SplashScreen";

function App() {
  const [showSplash, setShowSplash] = useState(true);
  const [hasShownSplash, setHasShownSplash] = useState(false);

  useEffect(() => {
    // Check if splash has been shown in this session
    const splashShown = sessionStorage.getItem('splashShown');
    if (splashShown) {
      setShowSplash(false);
      setHasShownSplash(true);
    }
  }, []);

  const handleSplashComplete = () => {
    setShowSplash(false);
    setHasShownSplash(true);
    sessionStorage.setItem('splashShown', 'true');
  };

  return (
    <LanguageProvider>
      {showSplash && !hasShownSplash && <SplashScreen onComplete={handleSplashComplete} />}
      <BrowserRouter>
        <div className="App">
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pos" element={<POSDevices />} />
            <Route path="/wallet" element={<Wallet />} />
            <Route path="/who-is-roya-for" element={<WhoIsRoyaFor />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
          <Toaster />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
